export const DEFAULT_AVATAR_SRC = process.env.PUBLIC_URL + '/avatar-placeholder.svg';

export const colors = ['#DBEEB7', '#F5DDDA', '#FFFBE3', '#CEEAD3', '#CDE7EC', '#E7F3FE', '#E8DDFA', '#F2F2F2', '#C3E0FC', '#C0F2F6', '#C6F3E8', '#E1F1B5', '#FFF5B8', '#F8E5CB', '#E4E7F9', '#FAE1E7', '#EEE4FA'];
